import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

// 코믹 컷 전체 보기 라이트박스. fetchComicCuts(seq)로 컷 목록을 받아 세로로 나열한다.
const ComicCutsViewer = props => {
  const { comic, fetchComicCuts, onClose } = props

  const [cuts, setCuts] = useState(null)

  useEffect(() => {
    let mounted = true

    fetchComicCuts(comic.seq).then(list => {
      if (mounted) setCuts(list)
    })

    return () => {
      mounted = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comic.seq])

  return (
    <Overlay onClick={onClose}>
      <CloseButton onClick={onClose}>×</CloseButton>
      <CutsColumn onClick={e => e.stopPropagation()}>
        <div id="title">
          {comic.title || `Comic #${comic.seq}`}
          <span id="sub">
            {comic.cutCount}컷{comic.layout ? ` · ${comic.layout}` : ''}
          </span>
        </div>
        {cuts == null && <div id="loading">컷을 불러오는 중...</div>}
        {cuts != null && cuts.length === 0 && (
          <div id="loading">컷 이미지가 없습니다.</div>
        )}
        {(cuts || []).map((cut, i) => (
          <CutBox key={i}>
            <img src={cut.imgUrl} alt={`cut ${cut.cutNo}`} />
            {cut.dialogue && <div id="dialogue">{cut.dialogue}</div>}
          </CutBox>
        ))}
      </CutsColumn>
    </Overlay>
  )
}

export default ComicCutsViewer

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  /* stretch(기본값)면 컷 컬럼이 화면 높이로 고정돼 8/12컷이 압축·클리핑되고
     스크롤도 생기지 않는다. 콘텐츠 높이만큼 늘어나게 해서 오버레이가 스크롤되도록 한다. */
  align-items: flex-start;
  padding: 40px 0;
  cursor: zoom-out;
  overflow-y: auto;
`

const CloseButton = styled.button`
  position: fixed;
  top: 20px;
  right: 24px;
  z-index: 2001;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`

const CutsColumn = styled.div`
  width: min(520px, 92vw);
  display: flex;
  flex-direction: column;
  row-gap: 14px;
  cursor: default;

  #title {
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    display: flex;
    align-items: baseline;
    column-gap: 8px;

    #sub {
      font-size: 12px;
      font-weight: 400;
      color: #bbb;
    }
  }

  #loading {
    color: #bbb;
    text-align: center;
    padding: 40px 0;
  }
`

const CutBox = styled.div`
  flex-shrink: 0;
  background: #111;
  border-radius: 10px;
  overflow: hidden;

  img {
    width: 100%;
    display: block;
  }

  #dialogue {
    padding: 8px 12px;
    color: #ddd;
    font-size: 13px;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;
  }
`
